import { typeOf } from "mathjs"

export const getCitationCounts = (start: string, divLevel: number, source: string, sourceLevel: number, yValueType: string, xValueType: string, expressionTypeRollup: boolean = false) => {
  // start with start Values combine so that I can add more than one resource as start value
  // this gets referenced throughout as ?start
  const startValues = start.split(" ").map((value => `<${value}>`)).join(" ")
  const startValuesLine = "VALUES ?start {" + startValues + "}"
  let startWorkGroupConstraint = ""
  
      
      if (yValueType === "WorkGroup" && divLevel !== 1){
          startWorkGroupConstraint = [
          "?divlevel <http://scta.info/property/level> '" + divLevel + "' .",
          "?start <http://scta.info/property/hasExpression> ?starttoplevel .",
          "?divlevel <http://scta.info/property/isMemberOf> ?starttoplevel ."
        ].join(" ")
      }
      else if (yValueType === "WorkGroup" && divLevel === 1){
        startWorkGroupConstraint = [
          "?divlevel <http://scta.info/property/level> '1' .",
          "?start <http://scta.info/property/hasExpression> ?divlevel ."
        ].join(" ")
      }
      else if (yValueType === "structureType"){
        startWorkGroupConstraint = [
          "?divlevel <http://scta.info/property/structureType> ?start ."
        ].join(" ")
      }

      

      let startContainerConstraint = ""
      console.log(divLevel === 1)
      console.log(typeOf(divLevel))

      /// this conditional is added in order to allow the expression id to be an expression at any level. 
      // If the desired break down is at the supplied expression level itself, then level is set to 1 
      // and the value of ?divlevel is set to the supplied start values
      // if it is level to two or below then ?divleves are set to to the members of the supplied start values
      // this conctinued in the startLevelContsraint line that uses the divLevel to construct a sumLevel relative to 
      // true starting level of the supplied start value. So if divLevel is set to 1 and the actual level of the resource is 3
      //then the startCurrent level will be 3 and the divLevel (1) - 1 will be 0, the query will look for a resource at level 3
      // if the startCurrent level is 3 and the divLevel is 2 (meaning 1 below the level of the start resource)
      // then startCurrentLevel 3 + (2 - 1) will be 4, so the query will look for a resource at level 4.
      if (yValueType === "TopLevelExpression" && divLevel === 1){
        console.log("Test")
        startContainerConstraint = "VALUES ?divlevel {" + startValues + "}"
      }
      else if (yValueType === "TopLevelExpression") {
        console.log("Test2")
        console.log("divLevel", divLevel)
        startContainerConstraint = "{?divlevel <http://scta.info/property/isMemberOf> ?start .}"
      }
      
      const startCurrentLevel = yValueType === "TopLevelExpression" ? "?start <http://scta.info/property/level> ?startCurrentLevel . " : ""
      const startCurrentParent = yValueType === "TopLevelExpression" ? "?start <http://purl.org/dc/terms/isPartOf> ?startCurrentParent . " : ""
      // const startLevelConstraint = yValueType === "TopLevelExpression" ? "?divlevel <http://scta.info/property/level> '" + divLevel + "' . " : ""
      // bind is added here so that if the resource provided is not top level, the level specified level will be relative to the level of the resource
      // this might break existing functionality
      const startLevelConstraint = yValueType === "TopLevelExpression" ? 
      "BIND((xsd:integer(?startCurrentLevel) + xsd:integer(" + (divLevel - 1) + ")) AS ?sumLevel) . BIND(STR(?sumLevel) AS ?sumLevelString) . ?divlevel <http://scta.info/property/level> ?sumLevelString . "
      : ""


      // second optional statement is graph item order number if div level is below item level
      // so that a new order number can be constructed from the item order and the div level order
      let startLevelOrder = ""
      if (yValueType === "TopLevelExpression" || yValueType === "ExpressionType"){
        startLevelOrder = [
        "OPTIONAL{?divlevel <http://scta.info/property/totalOrderNumber> ?divlevelorder .}",
        "OPTIONAL{",
            "?divlevel <http://scta.info/property/isPartOfStructureItem> ?startDivItem .",
            "?startDivItem <http://scta.info/property/totalOrderNumber> ?startDivItemNumber .",
          "}",
         ].join(" ")
      }
      
      
      //const startExpressionTypeConstraint = yValueType === "ExpressionType" ? "?divlevel <http://scta.info/property/expressionType> <" + start + "> ." : ""
      // NOTE:below is experiment for viewing all sub expression types side by side; it kind of works, but it doesn't group texts by expression type
      let startExpressionTypeConstraint = "" 
      // // if (yValueType === "ExpressionType"){
      // //   startExpressionTypeConstraint = "?divlevel <http://scta.info/property/expressionType> <" + start + "> ."
      // // }
      // // group sub parts
      if (yValueType === "ExpressionType" && expressionTypeRollup){
        startExpressionTypeConstraint = `?refquote <http://scta.info/property/isMemberOf> ?x .  
          ?x <http://scta.info/property/expressionType> ?divlevel .
          ?divlevel <http://scta.info/property/expressionType> ?start .`
      }
      else
      {
        startExpressionTypeConstraint = yValueType === "ExpressionType" ? "?divlevel <http://scta.info/property/expressionType> ?start ." : ""
      }
      
      // Begins Source constraints

      const sourceCurrentLevel = xValueType === "TopLevelExpression" ? "<" + source + "> <http://scta.info/property/level> ?sourceCurrentLevel . " : ""
      const sourceCurrentParent = xValueType === "TopLevelExpression" ? "<" + source + "> <http://purl.org/dc/terms/isPartOf> ?sourceCurrentParent . " : ""
      
      // second optional statement is graph item order number if source div level is below item level
      // so that a new order number can be constructed from the item order and the source div level order
      let sourceLevelOrder = ""
      if (xValueType === "TopLevelExpression"){
         sourceLevelOrder = [
          "OPTIONAL{?sourcedivlevel <http://scta.info/property/totalOrderNumber> ?sourcedivlevelorder .}",
          "OPTIONAL{",
            "?sourcedivlevel <http://scta.info/property/isPartOfStructureItem> ?sourceItem .",
            "?sourceItem <http://scta.info/property/totalOrderNumber> ?sourceItemNumber .",
          "}",
         ].join(" ")
      }
      
      const sourceBnSource = [
        "{",
        "?refquote <http://scta.info/property/source> ?source .  ",
        "}",
        "UNION", 
        "{",
          "?refquote <http://scta.info/property/source> ?bn .  ",
          "?bn <http://scta.info/property/source> ?source .  ",
        "}"
      ].join(" ")

      const sourceDivLevelBnSourceSourceDivLevel = [
        "{",
        "?refquote <http://scta.info/property/source> ?sourcedivlevel .  ",
        "}",
        "UNION", 
        "{",
          "?refquote <http://scta.info/property/source> ?bn .  ",
          "?bn <http://scta.info/property/source> ?sourcedivlevel .  ",
        "}"
      ].join(" ")

      const sourceConstraint = xValueType === "TopLevelExpression" ? [
        "{", 
            //"?refquote <http://scta.info/property/source> ?source .  ",
            sourceBnSource,
            "?source <http://scta.info/property/isMemberOf> ?sourcedivlevel .  ",
            "?sourcedivlevel <http://scta.info/property/isMemberOf> <" + source + "> .",
            "?sourcedivlevel <http://scta.info/property/level> '" + sourceLevel + "' .",
          "}", 
          "UNION ",
          "{", 
            //"?refquote <http://scta.info/property/source> ?sourcedivlevel .",
            sourceDivLevelBnSourceSourceDivLevel,
            "?sourcedivlevel <http://scta.info/property/isMemberOf> <" + source + "> . ",
            "?sourcedivlevel <http://scta.info/property/level> '" + sourceLevel + "' .",
          "}", 
      ].join(" ") : "";

      let sourceWorkGroupConstraint = "" 
      if (xValueType === "WorkGroup" && sourceLevel !== 1){
        sourceWorkGroupConstraint = [
        "{", 
            //"?refquote <http://scta.info/property/source> ?source .  ",
            sourceBnSource,
            "?source <http://scta.info/property/isMemberOf> ?sourcedivlevel .  ",
            "?sourcedivlevel <http://scta.info/property/level> '" + sourceLevel + "' .",
            // "<" + source + "> <http://scta.info/property/hasExpression> ?sourcedivlevel .",
            "<" + source + "> <http://scta.info/property/hasExpression> ?sourcetoplevel .",
            "?sourcedivlevel <http://scta.info/property/isMemberOf> ?sourcetoplevel .",
          "}", 
          "UNION ",
          "{", 
            //"?refquote <http://scta.info/property/source> ?sourcedivlevel .",
            sourceDivLevelBnSourceSourceDivLevel,
            "?sourcedivlevel <http://scta.info/property/level> '" + sourceLevel + "' .",
            // "<" + source + "> <http://scta.info/property/hasExpression> ?sourcedivlevel .",
            "<" + source + "> <http://scta.info/property/hasExpression> ?sourcedivlevel .",
            "?sourcedivlevel <http://scta.info/property/isMemberOf> ?sourcedivlevel .",
          "}"
      ].join(" ")
    }
    else if (xValueType === "WorkGroup" && sourceLevel === 1){
      sourceWorkGroupConstraint = [
        "{", 
            //"?refquote <http://scta.info/property/source> ?source .  ",
            sourceBnSource,
            "?source <http://scta.info/property/isMemberOf> ?sourcedivlevel .  ",
            "?sourcedivlevel <http://scta.info/property/level> '1' .",
            "<" + source + "> <http://scta.info/property/hasExpression> ?sourcedivlevel .",
          "}", 
          "UNION ",
          "{", 
            //"?refquote <http://scta.info/property/source> ?sourcedivlevel .",
            sourceDivLevelBnSourceSourceDivLevel,
            "?sourcedivlevel <http://scta.info/property/level> '1' .",
            "<" + source + "> <http://scta.info/property/hasExpression> ?sourcedivlevel .",
          "}"
      ].join(" ")
    }
    else if (xValueType === "structureType"){
       sourceWorkGroupConstraint = [
        "{", 
            sourceBnSource,
            "?source <http://scta.info/property/isMemberOf> ?sourcedivlevel .  ",
            "?sourcedivlevel <http://scta.info/property/structureType> <" + source + "> .",
          "}", 
          "UNION ",
          "{", 
            //"?refquote <http://scta.info/property/source> ?sourcedivlevel .",
            sourceDivLevelBnSourceSourceDivLevel,
            "?sourcedivlevel <http://scta.info/property/structureType> <" + source + "> .",
          "}"
       ].join(" ")
    }

      const sourceExpressionTypeConstraint = xValueType === "ExpressionType" ? [
        "{", 
          //"?refquote <http://scta.info/property/source> ?source .  ",
          sourceBnSource,
          "?source <http://scta.info/property/isMemberOf> ?sourcedivlevel .  ",
          "?sourcedivlevel <http://scta.info/property/expressionType> <" + source + "> .",
        "}", 
        "UNION ",
        "{", 
          //"?refquote <http://scta.info/property/source> ?sourcedivlevel .",
          sourceDivLevelBnSourceSourceDivLevel,
          "?sourcedivlevel <http://scta.info/property/expressionType> <" + source + "> . ",
        "}", 
      ].join(" ") : "";

      const AllTopLevelsQuery = [
        "PREFIX xsd: <http://www.w3.org/2001/XMLSchema#> ",
        "SELECT ?divlevel ?sourcedivlevel (COUNT(?sourcedivlevel) AS ?count) ?divtitle ?divlongtitle ?divlevelorder ?author ?authorTitle ?authorBirthDate ?sourceAuthor ?sourceAuthorTitle ?sourceAuthorBirthDate ?sourcedivtitle ?sourcedivlongtitle ?startCurrentLevel ?startCurrentParent ?sourceCurrentLevel ?sourceCurrentParent ?sourcedivlevelorder ?sourceItemNumber ?startDivItemNumber ",
        "WHERE { ",
          startValuesLine,
          sourceWorkGroupConstraint,
          sourceExpressionTypeConstraint,
          sourceConstraint,
          sourceCurrentLevel,
          sourceCurrentParent,
          sourceLevelOrder,
          "?sourcedivlevel <http://purl.org/dc/elements/1.1/title> ?sourcedivtitle . ",
          "OPTIONAL{",
          "?sourcedivlevel <http://scta.info/property/longTitle> ?sourcedivlongtitle . ",
          "}",
            "OPTIONAL { ",
            "?sourcedivlevel <http://www.loc.gov/loc.terms/relators/AUT> ?sourceAuthor . ",
            "?sourceAuthor <http://purl.org/dc/elements/1.1/title> ?sourceAuthorTitle . ",
            "OPTIONAL { ",
              "?sourceAuthor <http://scta.info/property/dateOfBirth> ?sourceAuthorBirthDate . ",
            "}", 
          "}",
          "?refquote <http://scta.info/property/structureType> <http://scta.info/resource/structureElement> .  ",
          "?refquote a <http://scta.info/resource/expression> . ",
          (!startExpressionTypeConstraint || !expressionTypeRollup) ? "?refquote <http://scta.info/property/isMemberOf> ?divlevel .  " : "",
          startExpressionTypeConstraint,
          startContainerConstraint,
          startCurrentLevel,
          startCurrentParent,
          startLevelConstraint,
          startLevelOrder,
          // startWorkGroup1,
          // startWorkGroup2,
          startWorkGroupConstraint,
          "?divlevel <http://purl.org/dc/elements/1.1/title> ?divtitle . ",
          "OPTIONAL { ",
          "?divlevel <http://scta.info/property/longTitle> ?divlongtitle . ",
          "}",
          "OPTIONAL { ",
            "?divlevel <http://www.loc.gov/loc.terms/relators/AUT> ?author . ",
            "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle . ",
            "OPTIONAL { ",
              "?author <http://scta.info/property/dateOfBirth> ?authorBirthDate . ",
            "}", 
          "}", 
        "}", 
        "GROUP BY ?divlevel ?sourcedivlevel ?authorTitle ?author ?authorBirthDate ?sourceAuthor ?sourceAuthorBirthDate ?sourceAuthorTitle ?divtitle ?divlongtitle ?sourcedivtitle ?sourcedivlongtitle ?divlevelorder ?startCurrentLevel ?startCurrentParent ?sourceCurrentLevel ?sourceCurrentParent ?sourcedivlevelorder ?sourceItemNumber ?startDivItemNumber",
        "ORDER BY ?authorTitle ?divlevelorder",
                ].join(" ")
                //console.log(AllTopLevelsQuery)
                return AllTopLevelsQuery
}